/** Dispatched when pack opening should hide site chrome (footer) for distraction-free animation. */
export const PACK_OPENING_CHROME_EVENT = "mot-pack-opening-chrome";

export interface PackOpeningChromeDetail {
  distractionFree: boolean;
}

export function setPackOpeningDistractionFree(distractionFree: boolean) {
  if (typeof window === "undefined") {
    return;
  }
  window.dispatchEvent(
    new CustomEvent<PackOpeningChromeDetail>(PACK_OPENING_CHROME_EVENT, {
      detail: { distractionFree },
    }),
  );
}
